import { createAjaxAction } from "../../Common/_actions/AjaxAction";
import { InvalidatePaginationData } from "./UserDataActions";

export interface BatchProductDesignSelection {
  ids: number[]
  selectAll?: boolean
  excludeIds?: number[]
  filters?: {
    search?: string[]
    categories?: string[]
    collections?: string[]
  }
}

export enum ProductDesignActionType {
  BatchDeleteProductDesigns = 'PRODUCT_DESIGN_BATCH_DELETE_PRODUCT_DESIGNS',
}

export const appendBatchProductDesignSelection = (data: FormData, selection: BatchProductDesignSelection) => {
  if (selection.selectAll) {
    data.append('select_all', '1');

    selection.excludeIds?.forEach((productDesignId) => {
      data.append('exclude_ids[]', String(productDesignId));
    });

    if (selection.filters?.search && selection.filters.search.length > 0) {
      data.append('search', selection.filters.search.join(','));
    }

    if (selection.filters?.categories && selection.filters.categories.length > 0) {
      data.append('categories', selection.filters.categories.join(','));
    }

    if (selection.filters?.collections && selection.filters.collections.length > 0) {
      data.append('collections', selection.filters.collections.join(','));
    }

    return;
  }

  selection.ids.forEach((productDesignId) => {
    data.append('ids[]', String(productDesignId));
  });
}

export const BatchDeleteProductDesigns = (
  selection: BatchProductDesignSelection,
) => {
  const data = new FormData();

  appendBatchProductDesignSelection(data, selection);

  return createAjaxAction<{}>(ProductDesignActionType.BatchDeleteProductDesigns, {
    url: 'ajax/api/user/productDesigns/batch-delete',
    method: 'POST',
    data: data,
    onSuccess: (response, dispatch) => {
      dispatch(InvalidatePaginationData('productDesigns'))
    },
  });
}
